import { getApi } from "./core";
export async function getNftStats(id) {
    const resp = await getApi(`nfts/${id}/stats`);
    return resp;
}
